import { useAppUpdateAvailable } from '@backoffice-frontend/common'
import { Toast } from '@moia-dev/pace-web'
import { useSnackbar } from 'notistack'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

export const AppUpdateToast = () => {
  const { t } = useTranslation()
  const appUpdateAvailable = useAppUpdateAvailable()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const shownRef = useRef(false)

  useEffect(() => {
    if (appUpdateAvailable && !shownRef.current) {
      shownRef.current = true
      enqueueSnackbar(t('backofficeApp_appUpdate_message'), {
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'bottom',
        },
        persist: true,
        preventDuplicate: true,
        content: key => (
          <div role="status">
            <Toast
              variant="neutral"
              actionLabel={t('backofficeApp_appUpdate_action')}
              action={() => {
                closeSnackbar(key)
                window.location.reload()
              }}
            >
              {t('backofficeApp_appUpdate_message')}
            </Toast>
          </div>
        ),
      })
    }
  }, [appUpdateAvailable, enqueueSnackbar, closeSnackbar, t])

  return null
}
